import React, { FC } from 'react';

export type RTProviderProps = {
    useRT: () => void;
};

export const RTProvider: FC<RTProviderProps> = ({
    useRT = () => {
        /**
         * Required to prevent conditional use of custom hook.
         * The expected input is a hook function (not the result of executing the hook).
         * Check BookmarkModal.app.tsx in react-extensions for an example usage.
         */
    },
    children,
}) => {
    useRT();

    return <>{children}</>;
};
